import React from "react";
import { toast } from "react-toastify";
import "./ErrorBoundary.css";

class ComponentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      `ComponentErrorBoundary caught an error in ${
        this.props.componentName || "component"
      }:`,
      error,
      errorInfo
    );

    // Show a more specific toast notification
    toast.error(
      `Error in ${
        this.props.componentName || "component"
      }. Please try refreshing the page.`,
      {
        position: "top-right",
        autoClose: 4000,
      }
    );

    this.setState({ error: error });
  }

  handleRetry = () => {
    this.setState({
      hasError: false,
      error: null,
    });
  };

  render() {
    if (this.state.hasError) {
      // Show a compact error UI
      return (
        <div className="component-error-boundary">
          <div className="component-error-content">
            <div className="error-icon-small">⚠️</div>
            <h4>Something went wrong</h4>
            <p>
              {this.props.componentName
                ? `The ${this.props.componentName} component encountered an error.`
                : "This component encountered an error."}
            </p>
            <button
              className="btn-primary btn-small"
              onClick={this.handleRetry}>
              Try Again
            </button>

            {process.env.NODE_ENV === "development" && this.state.error && (
              <details className="error-details-small">
                <summary>Error Details</summary>
                <pre>{this.state.error.toString()}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ComponentErrorBoundary;
